import { render } from "./CardPrivateWebinar.vue?vue&type=template&id=bc2189a6"
import script from "./CardPrivateWebinar.vue?vue&type=script&lang=ts"
export * from "./CardPrivateWebinar.vue?vue&type=script&lang=ts"
script.render = render

export default script